import axios from 'axios';

const GetHistoryAPI = async (data, onSuccess, onError)=>{
    try{
        console.log("Printing data", data);
        const res = await axios.get("/get/history", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        console.log("history res", res);
        onSuccess && onSuccess(res);
    }
    catch(err){
        onError && onError(err);
    }
};

export default GetHistoryAPI;